export default __webpack_public_path__ + "static/media/callback_regular.d3964410.gif";